import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faVuejs, faFontAwesome, faGithub, faGoogle,
  faFacebookF, faTwitter, faTrello, faJira,
  faLinkedin, faSkype, faSlack, faDiscord,
  faWordpress, faLaravel, faCss3, faHtml5,
  faJs, faBootstrap, faPython, faPhp, faLinode,
  faCpanel, faGit, faElementor, faAngular,
} from '@fortawesome/free-brands-svg-icons';

import { faCopyright, faHandPointer, faBars } from '@fortawesome/free-solid-svg-icons';

library.add(
  faVuejs,
  faFontAwesome,
  faGithub,
  faGoogle,
  faFacebookF,
  faTwitter,
  faCopyright,
  faTrello,
  faJira,
  faLinkedin,
  faSkype,
  faSlack,
  faDiscord,
  faHandPointer,
  faWordpress,
  faLaravel,
  faCss3,
  faHtml5,
  faJs,
  faBootstrap,
  faPython,
  faPhp,
  faLinode,
  faCpanel,
  faGit,
  faElementor,
  faAngular,
  faBars,
);

export default FontAwesomeIcon;
